module.exports = __webpack_public_path__ + "img/reports.943071b8.png";